// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"caa4bd61","769":"d47178e6"}[chunkId] + ".chunk.js";
};